import StatusToken from '@admin/tokens/status'
import Panel from '@admin/components/panel'
import TeamToken from '@admin/tokens/team'
import React from 'react'

const mapPropsToPanel = (props, context) => ({
  title: 't(Referrals)',
  collection: {
    endpoint: '/api/admin/team/affiliate/referrals',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Team)', key: 'title', primary: true, format: TeamToken },
      { label: 't(Next Payout)', key: 'next_payout_date', collapsing: true, align: 'right', format: 'date' },
      { label: 't(Commission)', key: 'commission', collapsing: true, align: 'right', format: 'currency' },
      { label: 't(Status)', key: 'status', sort: 'status', collapsing: true, format: StatusToken }
    ],
    empty: {
      title: 't(No Referrals)',
      text: 't(You do not yet have any referrals)',
      svg: 'heart_handshake'
    },
    entity: 'team',
    defaultSort: { key: 'created_at', order: 'desc' }
  }
})

export default Panel(null, mapPropsToPanel)
